import { cn } from '@/lib/utils.ts'

type Props = {
  size?: 'sm'
  isBlocked?: boolean
  className?: string
}

export const BlockerIcon = ({ size, isBlocked, className }: Props) => {
  return (
    <img
      className={cn(size === 'sm' && 'w-3.5 h-3.5', className)}
      src={isBlocked ? '/images/blocker-icon.svg' : '/images/blocked-icon.svg'}
      alt="blocker icon"
    />
  )
}
